import {Alert, Button, Divider, Input, Link} from "@heroui/react";
import {useMutation, useQuery} from '@tanstack/react-query';
import repositories from '../../repositories.jsx';
import {useForm} from '@mantine/form';
import toast from 'react-hot-toast';
import {useNavigate, useParams} from 'react-router-dom';
import {useEffect, useState} from 'react';
import {reject} from 'lodash';

export default function AccountVerification() {
	const {token} = useParams();
	const navigate = useNavigate();
	
	const [errorMessage, setErrorMessage] = useState('');
	
	const onLoginSuccess = async (res) => {
		localStorage.setItem('token', res.token);
		navigate('/app');
	}
	useEffect(() => {
		setErrorMessage('')
		localStorage.removeItem('token');
	}, []);
	
	const onSubmit = useQuery({
		queryFn: () => repositories.auth.verifyAccount(token).then((res) => {
			toast.success('Account successfully verified.')
			onLoginSuccess(res)
			return res;
		}).catch((error) => {
			setErrorMessage(error?.response?.data?.detail || 'Something went wrong')
			toast.error(error?.response?.data?.detail || 'Something went wrong')
			navigate('/login');
		}),
	});
	return (
		<>
			<div className="flex flex-col gap-3 w-full max-w-lg mx-auto">
				<div className="">
					<h2 className="font-semibold mb-3 text-3xl">Account verification</h2>
					<p className="text-default-600 opacity-0"></p>
				</div>
				{onSubmit.isSuccess &&
						<>
							<Alert color="success" title="Account verification successfully." description={onSubmit.data?.detail || 'Please check your email for password reset link'}/>
						</>
				}
				{onSubmit.isError &&
						<>
							<Alert color="danger" title={errorMessage || 'Account already verified'}/>
						</>
				}
			</div>
		</>
	);
}
